export const PAYOUT_BANK_INFO = "PAYOUT_BANK_INFO";

export default (state = null, action) => {
    switch (action.type) {
        case PAYOUT_BANK_INFO:
            return action.payload;
        default:
            return state;
    }
}
